import { useContext } from "react"
import { ExtratoPagarmeFornecedorContext } from "./ExtratoPagarmeFornecedorContext"

export function useExtratoPagarmeFornecedorContext() {
    return useContext(ExtratoPagarmeFornecedorContext)
}
